import type { FunctionComponent } from 'react';
import * as T from './ConsultationRubricList.types';
import * as s from './ConsultationRubricList.css';
import Box from '@media-ui/core/src/components/Box/Box';
import Title from '@media-ui/core/src/components/Title';
import { RubricIconBySlug } from './ConsultationRubricList.config';
import Link from '@media-ui/core/src/components/Link';
import classNames from 'classnames';
import { counterTrigger } from 'Src/tools/counters';
const ConsultationRubricList: FunctionComponent<T.IConsultationRubricListProps> = (props) => {
    const { items, isCenteredTitle } = props;
    const renderHeader = () => {
        return (<div className={s.header}>
        <Title level="2">Темы консультаций</Title>
      </div>);
    };
    const handleClick = (clickCounterName?: string) => {
        if (clickCounterName) {
            counterTrigger(clickCounterName);
        }
    };
    return (<Box className={classNames(s.root, {
            [s.centered]: isCenteredTitle,
        })} classNameContent={s.content} header={renderHeader()}>
      <ul className={s.list}>
        {items.map(({ id, href, title, slug, clickCounterName }, index) => {
            const icon = RubricIconBySlug[slug];
            return (<li className={s.item} key={`${id}_${index}`}>
              {icon && <div className={s.icon}>{icon}</div>}
              <Link href={href} holder onClick={() => handleClick(clickCounterName)} target={slug === 'consult' ? '_blank' : '_self'}>
                {title}
              </Link>
            </li>);
        })}
      </ul>
    </Box>);
};
export default ConsultationRubricList;
